import { TrustBarItem } from '../components/sections/PageTrustBar';
import { TestimonialItem } from '../components/sections/PageTestimonials';
import { FeaturedFind } from '../components/sections/PageCollections';

export const FORM_URL = 'https://readdy.ai/api/form/d6vv9uvb245v7h34ot7g';

export const MAP_EMBED =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3305.0!2d-112.757!3d34.218!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d5a0b2f7a3c3c3%3A0x1!2sYarnell+Emporium%2C+22899+S+Hwy+89%2C+Yarnell%2C+AZ+85362!5e0!3m2!1sen!2sus!4v1680000000000!5m2!1sen!2sus';

export const SERVICE_AREAS = ['Yarnell', 'Prescott', 'Wickenburg', 'Phoenix', 'Visitors & Travelers'];

export const SERVICE_ADDRESS = '22899 S Hwy 89, Yarnell, AZ 85362';
export const SERVICE_HOURS = 'Open Every Day\n9:00 AM – 5:00 PM';
export const SERVICE_PHONE = '928.427-9593';

export const TRUST_BAR_HOME: TrustBarItem[] = [
  { icon: 'ri-sparkling-line', label: 'One-of-a-Kind Inventory' },
  { icon: 'ri-map-pin-2-line', label: 'Locally Curated Finds' },
  { icon: 'ri-refresh-line', label: 'New Items Added Weekly' },
  { icon: 'ri-store-2-line', label: 'Boutique Shopping Experience' },
  { icon: 'ri-time-line', label: 'Open Every Day 9–5' },
  { icon: 'ri-vip-crown-line', label: 'Authentic Antiques' },
  { icon: 'ri-heart-line', label: 'Locally Owned & Operated' },
];

export const TESTIMONIALS: TestimonialItem[] = [
  {
    quote:
      'Every time I visit Yarnell Emporium I find something completely new. The antiques are incredible — real pieces with real history. It\'s become a must-stop whenever I\'m near Yarnell.',
    author: 'Margaret H.',
    location: 'Prescott, AZ',
    rating: 5,
  },
  {
    quote:
      'Such a fun and unique shopping experience. The furniture selection is unlike anything you\'d find at a normal store — each piece has its own character and charm.',
    author: 'Robert K.',
    location: 'Phoenix, AZ',
    rating: 5,
  },
  {
    quote:
      'I found the most beautiful gift here for my mother\'s birthday. The staff was incredibly helpful and the variety of items is just stunning. Will definitely be back.',
    author: 'Lisa T.',
    location: 'Wickenburg, AZ',
    rating: 5,
  },
  {
    quote:
      'The boutique apparel section is a hidden gem. Found pieces here I\'ve never seen anywhere else. It\'s a true destination shop — worth the drive from Phoenix.',
    author: 'Sarah M.',
    location: 'Scottsdale, AZ',
    rating: 5,
  },
  {
    quote:
      'Stopped in while passing through Yarnell and spent over an hour browsing. The inventory changes so often that each visit feels fresh. Highly recommend to anyone who loves unique finds.',
    author: 'James W.',
    location: 'Wickenburg, AZ',
    rating: 5,
  },
];

export const FEATURED_FINDS_HOME: FeaturedFind[] = [
  {
    title: 'Brass Victorian Candlestick Set',
    tag: 'Antiques',
    href: '/collections/antiques',
    imageSrc:
      'https://public.readdy.ai/ai/img_res/7c493eb937a5720f630073cf6c6e918d.jpg',
  },
  {
    title: 'Reclaimed Oak Side Table',
    tag: 'Furniture',
    href: '/collections/furniture',
    imageSrc:
      'https://readdy.ai/api/search-image?query=rustic%20reclaimed%20oak%20wood%20side%20table%20distressed%20finish%20warm%20amber%20light%20editorial%20interior%20product%20photography%20vintage%20boutique%20unique%20piece&width=400&height=400&seq=ye-new-2&orientation=squarish',
  },
  {
    title: 'Artisan Ceramic Vase',
    tag: 'Gifts & Décor',
    href: '/collections/gifts',
    imageSrc:
      'https://readdy.ai/api/search-image?query=handmade%20artisan%20ceramic%20vase%20earth%20tones%20textured%20surface%20warm%20neutral%20background%20editorial%20product%20photography%20boutique%20gift%20shop%20curated&width=400&height=400&seq=ye-new-3&orientation=squarish',
  },
  {
    title: 'Linen Embroidered Blouse',
    tag: 'Boutique Apparel',
    href: '/collections/apparel',
    imageSrc:
      'https://readdy.ai/api/search-image?query=elegant%20linen%20blouse%20delicate%20embroidery%20natural%20cream%20fabric%20boutique%20fashion%20editorial%20photography%20warm%20minimal%20background%20curated%20women%20clothing&width=400&height=400&seq=ye-new-4&orientation=squarish',
  },
];
